import { MutationTree } from 'vuex';
import { ErrorDetail } from '../../../types';
import { NodeOtherAccountState } from './types';
import { Account } from '../../account/types';
import * as types from './mutation-types';
import { Node } from '../../node/types';

// その他アカウントの全てのエラーをクリアする
const resetAllErrors = (state: NodeOtherAccountState): void => {
    const searchState = state.search;
    searchState.error = false;
    searchState.errorCode = undefined;
    searchState.errorMsg = undefined;

    const createState = state.create;
    createState.error = false;
    createState.errorTitle = undefined;
    createState.errorDetails = undefined;

    const showState = state.show;
    showState.error = false;
    showState.errorCode = undefined;
    showState.errorMsg = undefined;

    const updateState = state.update;
    updateState.error = false;
    updateState.errorTitle = undefined;
    updateState.errorDetails = undefined;

    const destroyState = state.destroy;
    destroyState.error = false;
    destroyState.errorTitle = undefined;
    destroyState.errorDetails = undefined;
};

export const mutations: MutationTree<NodeOtherAccountState> = {
    // ノードその他アカウント一覧系
    [types.SEARCH_START](state) {
        resetAllErrors(state);
        const searchState = state.search;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.SEARCH_SUCCESS](state, payload: { count: number; other_accounts: Array<Account> }) {
        state.otherAccountCount = payload.count;
        state.otherAccounts = payload.other_accounts;

        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.SEARCH_FAILURE](state, payload: { code: string; message: string }) {
        const searchState = state.search;
        searchState.errorCode = payload.code;
        searchState.errorMsg = payload.message;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // その他アカウント追加系
    [types.NEW_ACCOUNTS](state) {
        resetAllErrors(state);
    },

    [types.CREATE_START](state) {
        resetAllErrors(state);
        const createState = state.create;
        createState.isProcessing = true;
    },

    [types.CREATE_SUCCESS](state) {
        const createState = state.create;
        createState.isProcessing = false;
    },

    [types.CREATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const createState = state.create;
        createState.errorTitle = payload.errorTitle;
        createState.errorDetails = payload.errorDetails;
        createState.error = true;
        createState.isProcessing = false;
    },

    // その他アカウント検索データクリア
    [types.CLEAR_WORK](state) {
        state.wkOtherAccountCount = 0;
        state.wkOtherAccounts = undefined;
    },

    // ノードその他アカウント詳細情報参照系
    [types.SHOW_START](state) {
        resetAllErrors(state);
        const showState = state.show;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;
    },

    [types.SHOW_SUCCESS](state, payload: { other_account: Account; node: Node }) {
        state.otherAccountDetails.account = payload.other_account;
        state.otherAccountDetails.node = payload.node;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = true;
    },

    [types.SHOW_FAILURE](state, payload: { code: string; message: string }) {
        const showState = state.show;
        showState.errorCode = payload.code;
        showState.errorMsg = payload.message;
        showState.error = true;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    // ノードその他アカウント更新系
    [types.UPDATE_START](state) {
        resetAllErrors(state);
        const updateState = state.update;
        updateState.isProcessing = true;
    },

    [types.UPDATE_SUCCESS](state) {
        const updateState = state.update;
        updateState.isProcessing = false;
    },

    [types.UPDATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const updateState = state.update;
        updateState.errorTitle = payload.errorTitle;
        updateState.errorDetails = payload.errorDetails;
        updateState.error = true;
        updateState.isProcessing = false;
    },

    // その他アカウント削減系
    [types.DESTROY_START](state) {
        resetAllErrors(state);
        const destroyState = state.destroy;
        destroyState.isProcessing = true;
    },

    [types.DESTROY_SUCCESS](state) {
        const destroyState = state.destroy;
        destroyState.isProcessing = false;
    },

    [types.DESTROY_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const destroyState = state.destroy;
        destroyState.errorTitle = payload.errorTitle;
        destroyState.errorDetails = payload.errorDetails;
        destroyState.error = true;
        destroyState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;

        const createState = state.create;
        createState.isProcessing = false;

        const updateState = state.update;
        updateState.isProcessing = false;

        const destroyState = state.destroy;
        destroyState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        resetAllErrors(state);
        state.otherAccounts = undefined;
        state.otherAccountCount = 0;

        state.otherAccountDetails.account = undefined;
        state.otherAccountDetails.node = undefined;

        state.wkOtherAccounts = undefined;
        state.wkOtherAccountCount = 0;
    },
};
